import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { QuickTour } from "..";

interface QuickTourState {
  tours: QuickTour[];
  currentTour: string | null;
  currentStep: number | null;
}

// All data related to the user
const initialState: QuickTourState = {
  tours: [],
  currentTour: null,
  currentStep: null,
};

export const quickTourSlice = createSlice({
  name: "quickTour",
  initialState: initialState,
  reducers: {
    addTour: (state, action: PayloadAction<QuickTour>) => {
      if (state.tours.find((tour) => tour.name === action.payload.name)) return;
      state.tours.push(action.payload);
    },
    setCurrentTour: (state, action: PayloadAction<string>) => {
      state.currentTour = action.payload;
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    startTour: (state, action: PayloadAction<string>) => {
      state.currentTour = action.payload;
      state.currentStep = 0;
    },
    finishTour: (state) => {
      state.currentTour = null;
      state.currentStep = null;
    },
    nextStep: (state) => {
      if (state.currentTour === null || state.currentStep === null) return;
      const tour = state.tours.find(
        (tour: QuickTour) => tour.name === state.currentTour
      );
      if (tour === undefined) return;
      if (state.currentStep + 1 >= tour.steps.length) {
        state.currentTour = null;
        state.currentStep = null;
      } else {
        state.currentStep = state.currentStep + 1;
      }
    },
  },
});

export const QuickTourActions = quickTourSlice.actions;

export const quickTourReducer = quickTourSlice.reducer;
